<template>
  <div class="order-group">
    <div
      class="order-group__title"
      :style="{
        color: $store.infoscreenData.infoboardWindowColor,
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ ISSUING_STAGE_TRANSLATIONS[this.name] | translate }}
    </div>
    <transition name="flip">
      <div class="order-group__list" v-if="!hidden">
        <TicketSingleLine
          v-for="(ticket, index) in list[currentIndex]"
          :key="index"
          :index="index"
          :ticket="ticket"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import TicketSingleLine from '../tickets/TicketSingleLine';

import ContentCyclingMixin from '../../mixins/ContentCyclingMixin';
import {ISSUING_STAGE_TRANSLATIONS} from '../../config';

export default {
  name: 'GroupByOrder',
  components: {TicketSingleLine},
  mixins: [ContentCyclingMixin],
  props: {
    name: {type: String},
    tickets: {type: Array}
  },
  data() {
    return {
      ISSUING_STAGE_TRANSLATIONS
    };
  }
};
</script>

<style lang="scss" scoped>
.order-group {
  height: 100%;
  width: calc(100% / 3);
  padding: 3.426vh 0 1.76vh 0;
  overflow: hidden;
  perspective: 200vw;

  &:not(:last-child) {
    border-right-style: solid;
    border-right-width: max(0.417vw, 8px);
  }

  &__title {
    white-space: nowrap;
    font-size: 2.91666667vw;
    font-weight: 600;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__list {
    padding: 3vh 0;
  }
}
.flip-enter-active,
.flip-leave-active {
  transition: all 0.5s;
}
.flip-enter {
  opacity: 0;
  transform: rotateY(-90deg);
}
.flip-leave-to {
  opacity: 0;
  transform: rotateY(90deg);
}
</style>
